import React, { useState, useEffect } from "react";
import Header from "../../components/header1/Header1";
import { useNavigate } from "react-router-dom";
import bannerImage from "../../elements/hero-banner-landing-page.png";
import Footer from "../../components/footer/Footer";
import {
  fetchLearningTracks,
  assignTrackToStudent,
} from "../../services/studentportalapis";
import KnowMore from "./KnowMore";

const LearningTrack = () => {
  const [cardsPerRow, setCardsPerRow] = useState(3);
  const navigate = useNavigate();
  const [selectedCard, setSelectedCard] = useState(null);
  const [isEnrolled, setIsEnrolled] = useState(false);
  const [courseDetails, setCourseDetails] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedTrackName, setselectedTrackName] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showKnowMorePopup, setShowKnowMorePopup] = useState(false);
  const [selectedTrackId, setSelectedTrackId] = useState(null);

  const handleKnowMore = (trackId, trackName) => {
    setSelectedTrackId(trackId);
    setselectedTrackName(trackName);
    setShowKnowMorePopup(true);
  };

  const closeKnowMorePopup = () => {
    setShowKnowMorePopup(false);
    setSelectedTrackId(null);
  };

  useEffect(() => {
    fetchLearningTracks()
      .then((data) => setCourseDetails(data))
      .catch((err) => console.error("Error fetching student tracks:", err));
  }, []);

  const handleRadioChange = (id) => {
    setSelectedCard(id);
    const selectedCourse = courseDetails.find((track) => track.trackId === id);
    console.log("Selected Course:", selectedCourse?.trackName);
  };

  // const handleKnowMore = (trackName,id) =>{
  //     navigate(`/knowMore/${trackName}/${id}`)
  // };

  const handleEnroll = (courseName, id) => {
    setSelectedId(id);
    setShowConfirmation(true);
  };

  const confirmEnrollment = () => {
    const studentId = JSON.parse(localStorage.getItem("student-details"))[
      "studentId"
    ];
    if (selectedId) {
      assignTrackToStudent(studentId, selectedId)
        .then(() => {
          console.log("Successfully assigned track:", selectedId);
          setIsEnrolled(true);
          setShowConfirmation(false);
          navigate(
            `/track/${
              courseDetails.find((track) => track.trackId === selectedId)
                ?.trackName
            }/${selectedId}`
          );
        })
        .catch((err) =>
          console.error("Error assigning track to student:", err)
        );
    }
  };

  const handleEditEnrollment = () => {
    setShowConfirmation(false);
  };

  return (
    <div className="md:mx-20 sm:mx-10">
      <Header />
      <div className="relative w-full">
        <img
          src={bannerImage}
          alt="Banner"
          className="w-full sm:h-[300px] h-auto object-cover"
        />
        <div className="absolute inset-0 flex items-center justify-start top-0 left-0 text-white font-medium p-4 sm:p-6">
          <div className="flex flex-col w-full sm:w-2/5 p-3">
            <p className="text-xl sm:text-xl md:text-xl leading-snug mb-1 text-left break-words lg:text-3xl xl:text-4xl">
              Choose your Track and Discover your path to AI Mastery and
              Certification
            </p>
          </div>
        </div>
      </div>
      <div className="mainPage text-base xl:text-4xl">
        <p className="text-xl p-6 text-left font-normal text-black md:p-4 md:mx-10 md:text-xl sm:p-4 sm:mx-2 my-4">
          Under the Agivant AI Amplified Software Engineering program, you have
          the opportunity to get certified in{" "}
          <b>one of two specialized tracks</b>. Each track features a curated
          curriculum with hands-on learning and industry-relevant certifications
          to help you build expertise and stand out in the AI-driven world.
        </p>
        <div className="flex flex-col justify-center">
          <h2 className="text-xl sm:text-2xl md:text-4xl text-center font-bold">
            Choose Learning Track
          </h2>
          <p className="text-lg sm:text-lg font-semibold md:text-xl text-gray-500 text-center">
            Note: Please choose any one of the below tracks
          </p>
        </div>
        <div className="p-4 flex justify-center">
          <div
            className={`grid gap-4 ${
              cardsPerRow === 2
                ? "grid-cols-1 sm:grid-cols-2 "
                : "grid-cols-1 sm:grid-cols-2 lg:w-full max-w-4xl bg-white p-6"

            }`}
          >
            {courseDetails.map((card) => (
              <div
                key={card.trackId}
                onClick={() => handleRadioChange(card.trackId)}
                className={`border border-gray-900 flex flex-col justify-between rounded-lg p-4 transition-shadow relative cursor-pointer hover:scale-105 hover:shadow-md bg-white ${
                  selectedCard === card.trackId ? "shadow-lg  " : "shadow-md"
                }`}
              >
                <div className="flex flex-col top-2 left-2 items-center gap-2">
                  <input
                    type="radio"
                    id={`know-more-${card.trackId}`}
                    name="card-action"
                    className="w-5 h-5"
                    checked={selectedCard === card.trackId}
                    onChange={() => handleRadioChange(card.trackId)}
                  />
                  <h3 className="text-xl text-blue-800 sm:text-2xl md:text-4xl text-center font-bold ">
                    {card.trackName}
                  </h3>

                  <div className="flex flex-col my-4 justify-around">
                    <p className="text-base sm:text-base font-bold md:text-lg text-black text-center mb-1">
                      Career Path
                    </p>
                    <p className="text-base sm:text-base font-normal md:text-lg text-gray-400 md:leading-6 px-3">
                      {card.learningTrackDescription}
                    </p>
                  </div>
                </div>
                <div className="mt-4 mb-2 flex flex-col">
                  <button
                    className="text-gray-400 bg-white text-xl sm:text-xl font-normal md:text-2xl mb-1"
                    onClick={() => handleKnowMore(card.trackId, card.trackName)}
                  >
                    Know More
                  </button>
                  <button
                    className={`${
                      selectedCard === card.trackId && !isEnrolled
                        ? "bg-blue-500 text-white hover:bg-blue-600"
                        : "bg-gray-500 text-white cursor-not-allowed"
                    } px-2 py-2 rounded text-xl md:text-2xl mb-4`}
                    onClick={() =>
                      selectedCard === card.trackId &&
                      !isEnrolled &&
                      handleEnroll(card.trackName, card.trackId)
                    }
                    disabled={selectedCard !== card.trackId || isEnrolled}
                  >
                    Enroll Now
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
        {showKnowMorePopup && selectedTrackId && (
          <div className="fixed inset-0 bg-gray-500 bg-opacity-50 z-50 flex justify-center items-center p-4">
            <div
              className="bg-white p-2 rounded-md shadow-lg md:w-3/4 max-w-lg overflow-y-auto max-h-[80vh] scrollbar-hide
            [&::-webkit-scrollbar]:[width:10px]
            [&::-webkit-scrollbar-thumb]:bg-transparent
            [&::-webkit-scrollbar-thumb]:[border-radius:10px]
            overflow-x-hidden "
            >
              <KnowMore
                trackId={selectedTrackId}
                trackName={selectedTrackName}
                onClose={closeKnowMorePopup}
              />
            </div>
          </div>
        )}

        {showConfirmation && (
          <div className="fixed inset-0 bg-gray-500 bg-opacity-50 z-50 flex justify-center items-center p-4">
            <div className="bg-white py-4 px-8 rounded-xl shadow-lg">
              <p className="text-xl font-bold text-center md:leading-4 mb-1">
                Are you sure to Enroll with{" "}
                <span className="text-blue-800">
                  {
                    courseDetails.find((card) => card.trackId === selectedCard)
                      ?.trackName
                  }
                </span>{" "}
                Track?
              </p>
              <p className="text-xl font-semibold text-gray-500 text-center">
                Once chosen, your track cannot be changed.
              </p>
              <div className="flex flex-col justify-around items-center mt-4 text-center space-y-1">
                <button
                  className="bg-green-700 tracking-normal leading-snug font-bold text-2xl text-white w-1/2 rounded-md mb-1"
                  onClick={confirmEnrollment}
                >
                  Confirm
                </button>
                <button
                  className="bg-white tracking-normal font-bold text-2xl text-gray-400 mt-0 py-0 rounded-md"
                  onClick={handleEditEnrollment}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default LearningTrack;
